import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://kokriweb.in/" target="_blank"  rel="noreferrer">
            Kokri Web Solutions
          </a>{" "}
          2026

        </p>
      </div>
    </div>
  );
};

export default Footer;
